import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'ageLimit',
    standalone: false
})
export class AgeLimitPipe implements PipeTransform {

  transform(value: number): any {
    const today  = new Date();
    const returnedYear = new Date();
    // console.log(returnedYear.setFullYear(today.getFullYear() - value));
    return returnedYear.setFullYear(today.getFullYear() - value);
  }

}
